"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _text = require("@mmc/text");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * ## CommonI18N - component
 *
 * Used for any Translation Formatting needed
 */
// This is a table where we will map locales that want prices spoofed as target locales
var localeSwap = {
  'ro-RO': 'es-ES',
  'fr-BE': 'es-ES',
  'es-ES': 'it-IT'
};
/**
 *
 * Replaces a character between two digits
 *
 */

var replaceThousandsSeperator = function replaceThousandsSeperator(priceString, currentSeperator, updatedSeperator) {
  var thousandsSeperatorRegExp = new RegExp("(\\d)(" + currentSeperator + ")(\\d)", 'g');
  return priceString.replace(thousandsSeperatorRegExp, "$1" + updatedSeperator + "$3");
}; // This is a table where we will add override formatting functions for specific locales


var formatOverrideFunctions = {
  'nb-NO': function nbNO(priceString) {
    return replaceThousandsSeperator(priceString, ' ', '.');
  },
  'pt-PT': function ptPT(priceString) {
    return replaceThousandsSeperator(priceString, ' ', '.');
  }
};

var shouldLocaleSwap = function shouldLocaleSwap(locale) {
  return locale in localeSwap ? localeSwap[locale] : locale;
};

var overrideFormatting = function overrideFormatting(locale, formattedPrice, desiredFormat) {
  if (formatOverrideFunctions[locale] !== undefined) {
    return desiredFormat === 'string' ? formatOverrideFunctions[locale](formattedPrice) : /*#__PURE__*/_react["default"].createElement("span", {
      className: "notranslate"
    }, formatOverrideFunctions[locale](formattedPrice));
  }

  return desiredFormat === 'string' ? formattedPrice : /*#__PURE__*/_react["default"].createElement("span", {
    className: "notranslate"
  }, formattedPrice);
};

var CommonI18N = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(CommonI18N, _React$Component);

  function CommonI18N() {
    return _React$Component.apply(this, arguments) || this;
  }

  CommonI18N.resourceType = function resourceType() {
    return 'CommonI18N';
  };

  var _proto = CommonI18N.prototype;

  _proto.checkForError = function checkForError(format, options) {
    try {
      return this.renderFormatter(format, options);
    } catch (e) {
      throw new Error(e);
    }
  };

  _proto.formatPrice = function formatPrice(options, desiredFormat) {
    var returnZero = this.props.returnZero;
    var currency = options.currency,
        locale = options.locale,
        value = options.value,
        zeroMessage = options.zeroMessage,
        zeroMessageClass = options.zeroMessageClass; // Testing if any of the props are not avalible and if the value is equal to 0

    if (value === 0) {
      if (typeof zeroMessage === 'string' && zeroMessage.length > 1) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          "data-zeromessage": true,
          className: zeroMessageClass || ''
        }, zeroMessage);
      }

      if (returnZero !== true) {
        return ' ';
      }
    }

    if (value === undefined || value === null || !locale || !currency) {
      return ' ';
    }

    var formattedPrice = new Intl.NumberFormat(shouldLocaleSwap(locale), {
      // eslint-disable-line
      style: 'currency',
      currency: currency,
      minimumFractionDigits: this.checkIfDecimalsTrue(),
      maximumFractionDigits: this.checkIfDecimalsTrue(),
      currencyDisplay: 'symbol'
    }).format(value);
    return overrideFormatting(locale, formattedPrice, desiredFormat);
  }
  /**
   ** checks if the component wants deceimal places added to the price
   ** i.e. 600 vs. 600.00, 600 vs. 600.39
   */
  ;

  _proto.checkIfDecimalsTrue = function checkIfDecimalsTrue() {
    var returnDecimal = this.props.returnDecimal;

    if (returnDecimal === true) {
      return 2; // eslint-disable-line
    }

    return 0;
  };

  _proto.renderPrice = function renderPrice(options) {
    var _span;

    var displayValue = options.displayValue;
    /**
     *
     * If there is a displayValue this method formats it.
     * The formatPrice method will run if there isn't a displayValue
     *
     */

    if (displayValue) {
      var price = displayValue;
      var regex = /(###,###.##)/;
      var formattedPrice = this.formatPrice(options, 'string');

      if (typeof formattedPrice !== 'string' && formattedPrice.props['data-zeromessage'] === true) {
        return formattedPrice;
      }

      var priceArray = price.split(regex).map(function (pricePart) {
        if (regex.test(pricePart)) {
          return _span || (_span = /*#__PURE__*/_react["default"].createElement("span", {
            key: formattedPrice,
            className: "notranslate"
          }, formattedPrice));
        }

        return /*#__PURE__*/_react["default"].createElement("span", {
          key: pricePart
        }, pricePart);
      });
      return priceArray;
    }

    return this.formatPrice(options);
  }
  /**
   * set up for when there is other cases that need to be added (i.e. Date formatter)
    */
  ;

  _proto.renderFormatter = function renderFormatter(format, options) {
    switch (format) {
      case 'price':
        return this.renderPrice(options);

      default:
        return this.renderPrice(options);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        format = _this$props.format,
        options = _this$props.options,
        addPriceDisclaimer = _this$props.addPriceDisclaimer,
        priceDisclaimerId = _this$props.priceDisclaimerId,
        disclaimerData = _this$props.disclaimerData,
        className = _this$props.className;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.checkForError(format, options), addPriceDisclaimer && priceDisclaimerId && disclaimerData && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      className: className,
      tag: "span",
      text: " #" + priceDisclaimerId + "#",
      disclaimerData: disclaimerData
    }));
  };

  return CommonI18N;
}(_react["default"].Component);

exports["default"] = CommonI18N;
CommonI18N.displayName = 'CommonI18N';
CommonI18N.defaultProps = {
  returnZero: false,
  returnDecimal: false,
  addPriceDisclaimer: false
};